import {getElementFromSelector} from "bootstrap/js/src/util";
import {end} from "@popperjs/core";


global.oldPostCode = 0

// Ensure globals exist for Google Maps usage regardless of inline scripts
if (typeof window !== 'undefined') {
    if (typeof window.map === 'undefined') window.map = undefined;
    if (typeof window.drawLayerSite === 'undefined') window.drawLayerSite = undefined;
}

// ------------------------------------- MAP FORM VALIDATIONS --------------------------------------
window.emailValidate = function (field) {
    let regex = /^([_\-\.0-9a-zA-Z\+]+)@([_\-\.0-9a-zA-Z]+)(\.)+([a-zA-Z]{2,63})$/;

    if ($(field).val() === "") {
        $(field).css("border-color", "red");
        $('.email-error-msg').hide();
        $(field).next().show();
        return false
    } else if (!regex.test($(field).val())) {
        $(field).css("border-color", "red");
        $('.email-error-msg').css('display', 'block');
        return false
    } else {
        $(field).next().hide();
        $('.email-error-msg').hide();
        return true
    }
}

window.validateInput = function (field) {
    let error = true;
    var validableInput = $(field);
    if (validableInput.attr('name') === 'phone' && (validableInput.val().length >= 8 || validableInput.val().length <= 0)) $('.error-msg-phone').hide();
    if (!validableInput.is("input[type='hidden']") && !validableInput.hasClass('not_required')) {
        if (validableInput.val() === "" && validableInput.attr('name') !== 'mail') {
            validableInput.css("border-color", "red");
            validableInput.next().css('display', 'block');
            error = false;
        } else if (validableInput.is('input[type="checkbox"]') && !validableInput.is(':checked')) {
            validableInput.css("border-color", "red");
            validableInput.parent().parent().next().css('display', 'block');
            error = false;
        } else if (validableInput.attr('name') === 'phone' && validableInput.val().length < 8) {
            validableInput.css("border-color", "red");
            validableInput.next().hide();
            $('.error-msg-phone').show();
            error = false;
        } else {
            validableInput.css("border-color", "#4F4A54");
            validableInput.next().css('display', 'none');
            if (validableInput.is('input[type="checkbox"]')) validableInput.parent().parent().next().hide();
            if (validableInput.attr('name') === 'mail') {
                error = emailValidate(field);
            }
        }
    }
    return error
}

window.checkFields = function (form_inputs) {
    const $inputs = (form_inputs && form_inputs.jquery) ? form_inputs : $(form_inputs);
    if (!$inputs || $inputs.length === 0) return [];
    let results_array = [];
    $inputs.each(function () {
        results_array.push(validateInput(this))
    });
    $inputs.on("click keyup change", function () {
        validateInput(this)
    });
    return results_array
};

// Remove postcode-based AJAX autocomplete and wire Google Places to the address field
(function () {
    function ensureHiddenField(name, value) {
        const form = document.getElementById('msearch-form');
        if (!form) return;
        let input = form.querySelector('input[name="' + name + '"]');
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            form.appendChild(input);
        }
        if (typeof value !== 'undefined') input.value = value || '';
        return input;
    }

    function getAddressComponent(components, type) {
        const comp = (components || []).find(c => (c.types || []).includes(type));
        return comp ? comp.long_name : '';
    }

    function setFieldsFromComponents(components) {
        const streetNumber = getAddressComponent(components, 'street_number');
        const route = getAddressComponent(components, 'route');
        const postalCode = getAddressComponent(components, 'postal_code') || getAddressComponent(components, 'postal_code_suffix');
        const locality = getAddressComponent(components, 'locality') ||
            getAddressComponent(components, 'postal_town') ||
            getAddressComponent(components, 'sublocality') ||
            getAddressComponent(components, 'administrative_area_level_2');

        ensureHiddenField('houseNumber', streetNumber);
        ensureHiddenField('streetName', route);
        ensureHiddenField('postalCode', postalCode);
        ensureHiddenField('city', locality);

        // Enable button only if we have the minimum required components
        setBtnMapEnabled(!!(postalCode && route && locality));

        return {streetNumber, route, postalCode, locality};
    }

    function parseAndFillFromAddress(addressString, done) {
        if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
            return done(false);
        }
        const autocompleteService = new google.maps.places.AutocompleteService();
        autocompleteService.getPlacePredictions({ input: addressString, types: ['address'] }, function (predictions, status) {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions || predictions.length === 0) {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: addressString }, function (results, geoStatus) {
                    if (geoStatus === 'OK' && results && results[0]) {
                        setFieldsFromComponents(results[0].address_components || []);
                        return done(true);
                    }
                    return done(false);
                });
                return;
            }

            const placeId = predictions[0].place_id;
            const svc = new google.maps.places.PlacesService(document.createElement('div'));
            svc.getDetails({ placeId: placeId, fields: ['address_components'] }, function (place, detStatus) {
                if (detStatus === google.maps.places.PlacesServiceStatus.OK && place && place.address_components) {
                    setFieldsFromComponents(place.address_components);
                    return done(true);
                } else {
                    return done(false);
                }
            });
        });
    }

    function setupAddressAutocomplete() {
        const input = document.querySelector('#msearch-form input[name="search"]');
        if (!input) return;
        if (typeof google === 'undefined' || !google.maps || !google.maps.places) return;

        const autocomplete = new google.maps.places.Autocomplete(input, {
            types: ['address'],
            fields: ['address_components', 'geometry', 'formatted_address'],
            componentRestrictions: {country: 'BE'}
        });

        // Disable button whenever the user edits the input after a selection
        input.addEventListener('input', function () {
            setBtnMapEnabled(false);
        });

        autocomplete.addListener('place_changed', function () {
            const place = autocomplete.getPlace();
            const components = place && place.address_components ? place.address_components : [];
            setFieldsFromComponents(components);
        });
    }

    window.setupAddressAutocomplete = setupAddressAutocomplete;

    document.addEventListener('DOMContentLoaded', function () {
        setupAddressAutocomplete();

        $('#msearch-form').on('submit', function (e) {
            const $form = $(this);
            const addrInput = $form.find('input[name="search"]');
            const value = addrInput.val() ? addrInput.val().trim() : '';
            if (!value) {
                addrInput.css("border-color", "red");
                $form.find('.error-msg').show();
                return false;
            }

            // Block submission if the button is disabled (enforce autocomplete selection)
            const isDisabled = $('#btn_map').is(':disabled');
            if (isDisabled) {
                addrInput.css("border-color", "red");
                $form.find('.error-msg').show();
                return false;
            }

            if (typeof searchFormLoaderShow === 'function') searchFormLoaderShow();
            return true;
        });

        $('#unsubscribe-form').on('submit', function () {
            return !checkFields($('#unsubscribe-form input')).includes(false);
        });
    });
})();

// Defer jQuery-dependent init until DOM is ready to avoid early runtime errors
function setBtnMapEnabled(enabled) {
    var btn = document.getElementById('btn_map');
    if (!btn) return;
    if (enabled) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        if (window.$) $('#btn_map').attr('disabled', false);
    } else {
        btn.disabled = true;
        if (window.$) $('#btn_map').attr('disabled', true);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    // Disabled by default until a Google selection is made
    setBtnMapEnabled(false);

    if (!window.$) return;

    // Set initial size and observe resize of the side block
    const mapCheckBlock = document.getElementById('map-check-block');
    changeMapHeight($('#map-check-block'), 0);
    if (mapCheckBlock && window.ResizeObserver) {
        resizeObserver.observe(mapCheckBlock);
    }
});

document.addEventListener('turbolinks:load', function(){ setBtnMapEnabled(false); });

// ----------------------------- MAP--------------------------------------------------

const smSize = 992;

var featureCollection = {
    "type": "FeatureCollection",
    "features": []
};
var emptyFeature = {
    "type": "Feature",
    "properties": {},
    "geometry": {}
};

// Always define initMap for the Google Maps callback
function initMap() {
    const mapEl = document.getElementById("map");
    if (mapEl) {
        window.map = new google.maps.Map(mapEl, {
            center: {lat: 50.464952, lng: 4.865000},
            zoom: 9.32,
            disableDefaultUI: true,
        });
    }
    if (typeof window.setupAddressAutocomplete === 'function') {
        window.setupAddressAutocomplete();
    }
}

window.initMap = initMap;

window.changeLocation = function (address, lat, lng, geojson, bounds_northeast, bounds_southwest) {
    if ($(window).width() <= smSize) return false;
    const houseLatLng = new google.maps.LatLng(lat, lng)
    if (bounds_northeast[0] && bounds_southwest[0]) {
        let bound_min = new google.maps.LatLng(bounds_northeast[0], bounds_northeast[1])
        let bound_max = new google.maps.LatLng(bounds_southwest[0], bounds_southwest[1])
        window.map.fitBounds(new google.maps.LatLngBounds(bound_min, bound_max))
    } else window.map.setZoom(17);
    window.map.panTo(houseLatLng);

    featureCollection.features = [];
    var feature = clone(emptyFeature);
    feature.geometry = geojson;
    featureCollection.features.push(feature);
    reloadGeoJson(featureCollection)

}

window.clone = function (obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

window.reloadGeoJson = function (geoJson) {
    // Remove the old layer from the map, if it exists
    if (window.drawLayerSite && window.drawLayerSite.setMap)
        window.drawLayerSite.setMap(null);
    window.drawLayerSite = new google.maps.Data({
        map: window.map
    });
    window.drawLayerSite.setStyle({
        fillColor: 'rgba(237, 18, 95, 0.5)',
        fillOpacity: 0.5,
        strokeWeight: 1,
        strokeColor: '#ED125F',
        strokeOpacity: 0.8
    });
    window.drawLayerSite.addGeoJson(geoJson);
}


window.smoothZoom = function (map, max, cnt) {
    if (cnt >= max) {
        return;
    } else {
        z = google.maps.event.addListener(map, 'zoom_changed', function (event) {
            google.maps.event.removeListener(z);
            smoothZoom(map, max, cnt + 1);
        });
        setTimeout(function () {
            map.setZoom(cnt)
        }, 80); // 80ms is what I found to work well on my system -- it might not work well on all systems
    }
}

//----------------------------------FORM ANIMATIONS -----------------------------------------------------------

window.changeMapHeight = function (element, animationSpeed = 500) {
    // 70+94+45+100 = 309
    // 94px is margin-top of .map-container
    // 45px is a half of the margin-top of .communes-block-header
    // 70px is a margin-top of #map-check-block
    // 100px are top and bottom paddings (50px each) of #map-check-block
    $('#map').animate({height: `${element.height() + 309}px`}, animationSpeed);
}
window.backToForm = function () {
    // If we're on a result subroute, navigate back to the main map page
    if (window.location && /^\/fiber_map\//.test(window.location.pathname)) {
        window.location.assign('/fiber_map');
        return;
    }

    searchFormLoaderHide();
    changeBlocks($('#result-block'), $('.connection-map'), true);
    hideAdditionalContent();
    $('html, body').animate({scrollTop: 0}, 200);
}
window.addAddress = function (feedback_checker = false) {
    if (feedback_checker) {
        if (!$('#accept-policy-check').is(':checked')) {
            $('.error-msg').show()
            return
        } else $('.error-msg').hide()
    }
    changeBlocks($('.search_result'), $('#form_installation'))
    showAdditionalContent();
}
window.searchFormLoaderShow = function () {
    $('#btn_map').css('color', 'transparent');
    $('.loader-white').show()
}
window.searchFormLoaderHide = function () {
    $('#btn_map').css('color', 'white');
    $('.loader-white').hide();
}
window.changeBlocks = function (first, second, deleteFirst = false) {
    first.hide(
        'slide',
        {direction: 'left'}, 500,
        function () {
            second.show('slide', {direction: 'left'}, 500, function () {
                if (deleteFirst) first.empty();
            })
            $('html, body').animate({scrollTop: 0}, 200);
        })
}

// Remove unused top-level constants that depend on jQuery width
// const showParam = ($(window).width() >= smSize) ? {right: 0} : {top: 0};
// const hideParam = ($(window).width() >= smSize) ? {right: '-540px'} : {top: '-650px'};

window.showAdditionalContent = function () {
    let contentBlock = $('#additional-content');
    let parent = contentBlock.parent();
    $('#map-check-block').animate(
        {width: `${$('.container').first().width()}px`},
        300,
        function () {
            contentBlock.fadeIn(450, function () {
                $('#map-check-block').css('width', '100%')
            })
        }
    )
}
window.hideAdditionalContent = function () {
    let contentBlock = $('#additional-content');
    let mapLeftBlockWidth = $('#map-left-block').width()
    let paddingLength = Number($('#map-check-block').css('padding').split(" ")[0].slice(0, -2)) * 2
    contentBlock.fadeOut(450, function () {
        $('#map-check-block').animate({width: `${mapLeftBlockWidth + paddingLength}px`}, 300, function () {
            $('#map-check-block').css('width', 'fit-content')
        })
    })
}

const resizeObserver = new ResizeObserver(entries => {
    changeMapHeight($('#map-check-block'), 0);
});

// Moved ResizeObserver.observe and initial changeMapHeight into DOMContentLoaded above
